// Emergent open-with-prompt helper.
// The Emergent platform (https://emergent.sh) opens a builder chat when
// visited with a `prompt` query parameter — this mirrors the standard
// pattern used by other AI builder tools. If Emergent later changes the
// query key, only this file needs to update.

export const EMERGENT_BASE_URL = "https://app.emergent.sh/";

export function buildEmergentUrl(prompt) {
  const text = (prompt || "").trim();
  if (!text) return EMERGENT_BASE_URL;
  // Cap to avoid overly long URLs — some browsers still baulk past ~8 KB.
  const capped = text.slice(0, 6000);
  const encoded = encodeURIComponent(capped);
  return `${EMERGENT_BASE_URL}?prompt=${encoded}`;
}

/**
 * Open Emergent in a new tab with the prompt pre-loaded, AND copy the same
 * text to the clipboard as a graceful fallback in case the query-param
 * pre-load ever fails (user still has the text ready to paste).
 */
export async function openEmergentWithPrompt(prompt) {
  const url = buildEmergentUrl(prompt);
  try {
    await navigator.clipboard?.writeText(prompt || "");
  } catch { /* clipboard unavailable — no-op */ }
  window.open(url, "_blank", "noopener,noreferrer");
  return url;
}
